export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9115.75914953.jpg";